import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBQot7eFJRnq9I8pZ3mEqj-dBmFMUgXwLQ",
  authDomain: "quit-the-quit-app.firebaseapp.com",
  projectId: "quit-the-quit-app",
  storageBucket: "quit-the-quit-app.firebasestorage.app",
  messagingSenderId: "400956991246",
  appId: "1:400956991246:web:94465f88664e0849eb995f",
};

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
// Use indexedDBLocalPersistence first (works in Capacitor WKWebView on iOS),
// falling back to browserLocalPersistence for standard web browsers.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
});
export const storage = getStorage(app);
export const functions = getFunctions(app);
